import axios, { AxiosError } from "axios";
import { ReactElement } from "react";
import { AUTH_KEY } from "../contexts/AuthContext";
import { useAuth } from "../hooks/useAuth";
import { useLoading } from "../hooks/useLoading";

const BASE_URL = process.env.REACT_APP_API_URL

const axiosInstance = axios.create({
    baseURL: BASE_URL
})

export const axiosPublicInstance = axios.create({
    baseURL: BASE_URL
})

const AxiosInterceptor = ({ children }: { children?: ReactElement }) => {
    const { logout } = useAuth();
    const { setLoading } = useLoading();

    const request = axiosInstance.interceptors.request.use(
        async (config) => {
            const auth = localStorage.getItem(AUTH_KEY)
            const loginData = auth ? JSON.parse(auth) : null
            setLoading(true);
            config.headers["Content-Type"] = "application/json"
            config.headers["X-XSS-Protection"] = "1; mode=block"
            const now = new Date().getTime()
            if (loginData) {
                const expiresAt = new Date(loginData.content.authorization.expiresAt).getTime()
                if (now < expiresAt)
                    config.headers["X-Authorization"] = loginData.content.authorization.key
                else
                    logout()
            } else {
                logout()
            }
            return config
        },
        error => {
            setLoading(false);
            return Promise.reject(error)
        }
    )

    const response = axiosInstance.interceptors.response.use(
        (response) => {
            // console.log("------RESPONSE FROM SERVER: ", { response })
            setLoading(false);
            return response
        },
        (error: AxiosError) => {
            // console.error("--------RESPONSE ERROR: ", error)
            if (error.response?.status === 401 || error.response?.status === 403)
                logout();
            setLoading(false);
            return Promise.reject(error)
        }
    )

    if (request && response) {
        axiosInstance.interceptors.response.eject(response)
        axiosInstance.interceptors.request.eject(request)
    }

    return children ? children : <></>;
}

export { AxiosInterceptor };
export default axiosInstance;